import { Action, createReducer, on } from '@ngrx/store';

import { resetCloseWebViewInDetailAction, setCloseWebViewInDetailAction } from '@app/store/actions/global.actions';

export const initialState = false;

const featureReducer = createReducer(
  initialState,
  on(setCloseWebViewInDetailAction, (state, { payload }) => {
    if (payload) {
      const toBooleanString = payload.toLowerCase().trim();
      switch (toBooleanString) {
        case 'true': return true;
        case 'false': return false;
        default: return false;
      }
    } else return false;
  }),
  on(resetCloseWebViewInDetailAction, () => initialState)
);

export const closeWebViewInDetailReducer = (state: boolean, action: Action): boolean => {
  return featureReducer(state, action);
};
